const poll = (condition, delay, timeout) => {
    let interval;
    return new Promise(r => {
        const complete = () => {
            clearInterval(interval);
            r();
        };
        interval = setInterval(() => condition && complete(), delay);
        setTimeout(complete, timeout);
    });
};

export default poll;
